import Vue from "vue";
import Vuex from 'vuex'
import axios from "axios";

import philstocksResearch from './ResearchCMS/philstocks_research'
import { cookiesHandler } from "../utils/cookie_handler.js";

Vue.use(Vuex);
var instance = axios.create({
    baseURL: window.location.origin,
});

export default new Vuex.Store({
    namespace: true,
    state: {
        config: null
    },
    mutations: {
        SET_Config(state, config) {
            state.config = config;
        }
    },
    getters: {
        config(state) {
            return state.config;
        },
        token() {
            var token = cookiesHandler.methods.getCookie("sessionToken");

            if (token) {
                var base64Url = token.split('.')[1];
                var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                var jsonPayload = decodeURIComponent(Buffer.from(base64, "base64").toString("ascii").split("").map(function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                }).join(''));

                return JSON.parse(jsonPayload);
            }

            return token;
        },
    },
    actions: {
        // eslint-disable-next-line no-empty-pattern
        CreateTokenCookie({ }, token) {
            var payload = {
                name: "sessionToken",
                value: token,
            };

            cookiesHandler.methods.createCookie(payload);
        },
        // eslint-disable-next-line no-empty-pattern
        DeleteTokenCookie({ }) {
            cookiesHandler.methods.deleteCookie("sessionToken");
        },
        GetConfig({ commit }) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/misc/config")
                    .then(function (response) {
                        commit("SET_Config", response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },
        // eslint-disable-next-line no-empty-pattern
        ValidateToken({ }) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/misc/validate", {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        reject(error.response);
                    });
            });
        }
    },
    modules: {

        philstocksResearch
    },
});

